<template>
  <section class="free-onepass-membership-section">
    <div class="free-onepass-membership-container">
      <div v-if="content?.PageHtml" v-html="content.PageHtml" class="membership-content"></div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  content: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  section: {
    type: Object,
    default: () => ({}),
  },
  id: {
    type: [String, Number],
    default: null,
  },
  __typename: {
    type: String,
    default: null,
  },
});
</script>

<style scoped lang="scss">
.free-onepass-membership-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 0;
  background-color: #FFFFFF;
}

.free-onepass-membership-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  gap: 24px;
  max-width: 1252px;
  width: 100%;
}

.membership-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
}

:deep(.free-onepass-membership-title),
.free-onepass-membership-title {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 48px;
  text-align: center;
  letter-spacing: -0.01em;
  margin: 0;
  align-self: stretch;
}

:deep(.purple-text),
.purple-text {
  color: #9900F1;
}

:deep(.black-text),
.black-text {
  color: #333333;
}

:deep(.free-onepass-membership-subtitle),
.free-onepass-membership-subtitle {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #3B016A;
  margin: 0;
  max-width: 734px;
  align-self: stretch;
  margin-left: auto;
  margin-right: auto;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .free-onepass-membership-section {
    padding: 16px 0;
  }

  .free-onepass-membership-container {
    padding: 0 16px;
  }

  .membership-content {
    align-items: flex-start;
  }

  :deep(.free-onepass-membership-title),
  .free-onepass-membership-title {
    font-size: 32px;
    line-height: 40px;
    text-align: left;
  }

  :deep(.free-onepass-membership-subtitle),
  .free-onepass-membership-subtitle {
    text-align: left;
  }
}

@media (max-width: 480px) {
  :deep(.free-onepass-membership-title),
  .free-onepass-membership-title {
    font-size: 24px;
    line-height: 32px;
  }
}
</style>
